import React from "react";
import { logError } from "../utils/diagnostics";

// Catches render crashes anywhere below it, logs them, and shows a minimal fallback instead of a blank screen.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError("react_crash", error, {
      component_stack: errorInfo?.componentStack?.slice(0, 500),
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: "fixed",
            bottom: 16,
            right: 16,
            zIndex: 10000,
            padding: "10px 14px",
            borderRadius: 8,
            background: "#fff",
            color: "#333",
            fontSize: 13,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          Something went wrong. Please refresh the page.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
